var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDesconnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 18.3594C15.5483 20.2884 13.9407 21.9265 11.7871 21.8737C11.286 21.8615 10.6668 21.6869 9.42825 21.3375C6.44751 20.4967 3.85995 19.0836 3.23913 15.9182C3.125 15.3365 3.125 14.6817 3.125 13.3722V11.6278C3.125 10.3183 3.125 9.66359 3.23913 9.08173C3.85995 5.9163 6.44751 4.50329 9.42825 3.66253C10.6668 3.31316 11.286 3.13849 11.7871 3.12624C13.9407 3.07355 15.5483 4.71153 15.625 6.64063",
    stroke: "#FF3B30",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8763 12.5H10.418M21.8763 12.5C21.8763 11.7707 19.7989 10.4079 19.2721 9.89587M21.8763 12.5C21.8763 13.2294 19.7989 14.5922 19.2721 15.1042",
    stroke: "#FF3B30",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDesconnected);
export default __webpack_public_path__ + "static/media/iconDesconnected.86e66b8089e97849de59a67dc3b0012f.svg";
export { ForwardRef as ReactComponent };